angular
  .module("richiestaCessione.components", [])
  .component("richiestaCessione", {
    templateUrl: "ng/components/richiestaCessione/richiestaCessione.view.html",
    bindings: {},
    controllerAs: "richiestaCessioneCtrl",
    controller: function RichiestaCessione(
      $arcService,
      $modalService,
      $transactionFactory,
      $RichiestePostVenditaService,
      $location,
      $rootScope,
      Contratti,
      $userService,
      $timeout,
      validationService,
      RiUserG
    ) {
      var self = this;

      self.$onInit = function () {
        self.supportModel = {
          fatturazioneOk: false
        };
        self.insertUser = "";
        self.showMapInfo = false;
        self.mapInfo = "";
        self.datiAnagCompleti = false;
        self.appContracts = [{
          numeroContratto: "",
          modulo: "",
          prodotto: ""
        }];
        self.loaderObj = {
          enabledLoader: false
        }
        var model = $transactionFactory.get();
        self.visibleDownloadChecklist = false;
        self.visibleUploadChecklist = false;

        if (model) {
          self.dettaglioRichiesta = model;
          $transactionFactory.clear();
        } else {
          self.dettaglioRichiesta = dettaglioRichiesta.build();
        }

        if (self.dettaglioRichiesta.viewIndex == 0) {
          self.dettaglioRichiesta.viewIndex = 1450;
        }

        var contratti = [];
        if (self.dettaglioRichiesta.metadata.cessioneVoltura.contratti.length == 0) {
          self.dettaglioRichiesta.metadata.ctrRichiestaList.forEach(function (contratto) {
            contratti.push(Contratti.build({
              numero: contratto.numeroContratto,
              modulo: contratto.numeroModulo,
              selected: true,
              codProdotto: contratto.codProdotto,
              dscProdotto: contratto.dscProdotto,
              importo: contratto.importo
            }));
          });

          self.dettaglioRichiesta.metadata.cessioneVoltura.contratti = contratti;
        }

        //prendo l'utente collegato per passarlo in input alla mappa degli indirizzi del cessionario
        self.insertUser = self.dettaglioRichiesta.insertUser ? self.dettaglioRichiesta.insertUser : "";

        if (self.getWizardMap(self.dettaglioRichiesta.viewIndex) === "PCDCK" ||
          self.getWizardMap(self.dettaglioRichiesta.viewIndex) === "PCSCK" || self.dettaglioRichiesta.readOnly) {
          populateCheckList();
        }

        if (self.getWizardMap(self.dettaglioRichiesta.viewIndex) === "PQVA" || self.dettaglioRichiesta.readOnly) {
          self.dettaglioRichiesta.metadata.cessioneVoltura.contratti.forEach(function (contratto) {
            self.appContracts.forEach(function (element) {
              if (contratto.selected &&
                element.numeroContratto != contratto.numero && element.modulo != contratto.modulo) {
                self.appContracts.push({
                  numeroContratto: contratto.numero,
                  modulo: contratto.modulo,
                  prodotto: contratto.codProdotto,
                  dscProdotto: contratto.dscProdotto
                });
              }
            });
          });

          self.appContracts = self.appContracts.filter(function (element) {
            return element.numeroContratto != "" && element.modulo != "" && element.prodotto != ""
          });

          if(!self.dettaglioRichiesta.metadata.cessioneVoltura.questComplete) {
            retrieveQvaList();
          }

        }

        if (self.getWizardMap(self.dettaglioRichiesta.viewIndex) === "PCSDA") {
          self.dettaglioRichiesta.metadata.cessioneVoltura.fatturazioneElettronica =
            self.dettaglioRichiesta.metadata.cessioneVoltura.destinatario.sedeFatturazione.fatturazione;
        }

        retrieveStepInfo();
        getDealer()
        checkCf()
      };

      self.handleChange = function (property, value) {
        switch (property) {
          case "iban":
            self.dettaglioRichiesta.metadata.cessioneVoltura.autorizzazioneSDD =
              value;
            break;
          case "bei":
            self.dettaglioRichiesta.metadata.cessioneVoltura.questionarioBei =
              value;
            break;
          case "cervedUpdate":
            self.dettaglioRichiesta.metadata.cessioneVoltura.destinatario = value;
            self.cervedNotOk = value.datiIncompleti;
            break;
          case "categoria":
            self.dettaglioRichiesta.metadata.cessioneVoltura.qcc.categoria =
              value.name;
            self.dettaglioRichiesta.metadata.cessioneVoltura.qcc.codiceCategoria =
              value.value;
            break;
          case "advDigitale": //cedente --> ancora non presente in mappa
            self.dettaglioRichiesta.metadata.cessioneVoltura.advDigitale =
              value;
            break;
          case "nomeFirmatario":
            self.dettaglioRichiesta.metadata.cessioneVoltura.firmatario.nome =
              value;
            break;
          case "cognomeFirmatario":
            self.dettaglioRichiesta.metadata.cessioneVoltura.firmatario.cognome =
              value;
            break;
          case "cfFirmatario":
            self.dettaglioRichiesta.metadata.cessioneVoltura.firmatario.cf =
              value;
            break;
        }
        checkCf()
      };

      self.handleStructureChange = function (contatti) {
        self.dettaglioRichiesta.metadata.cessioneVoltura.contatti = contatti;
      };

      self.nextValidity = function () {
        if (self.getWizardMap(self.dettaglioRichiesta.viewIndex) === "PC11") {
          //dati cedente
          return self.validityDatiRichiesta && self.isContact;
        }
        if (
          self.getWizardMap(self.dettaglioRichiesta.viewIndex) === "PCDCK" ||
          self.getWizardMap(self.dettaglioRichiesta.viewIndex) === "PCSCK"
        ) {
          //checklist cedente
          return self.validityComponentUpload;
        }
        if (self.getWizardMap(self.dettaglioRichiesta.viewIndex) == "RIANAG") {
          return (
            !self.cervedNotOk &&
            (self.dettaglioRichiesta.metadata.cessioneVoltura
              .fatturazioneElettronica.cdDestinatarioFatturazione ||
              self.dettaglioRichiesta.metadata.cessioneVoltura
                .fatturazioneElettronica.emailFatturazioneElettronica)
          );
        }
        if (self.getWizardMap(self.dettaglioRichiesta.viewIndex) == "PCSDA") {
          return (
            self.isIban &&
            (self.checkCategory ||
              self.dettaglioRichiesta.metadata.cessioneVoltura.qcc
                .consensiOk) &&
            self.dettaglioRichiesta.metadata.cessioneVoltura.qcc &&
            self.dettaglioRichiesta.metadata.cessioneVoltura.qcc.name &&
            self.dettaglioRichiesta.metadata.cessioneVoltura.qcc.value &&
            !self.gettingDealer &&
            self.dettaglioRichiesta.metadata.cessioneVoltura.firmatario.nome &&
            self.dettaglioRichiesta.metadata.cessioneVoltura.firmatario
              .cognome &&
            self.dettaglioRichiesta.metadata.cessioneVoltura.firmatario.cf &&
            self.codiceFiscaleOk
          );
        }
        if (
          self.getWizardMap(self.dettaglioRichiesta.viewIndex) == "PMPLINST"
        ) {
          //indirizzi cessionario
          if (
            self.dettaglioRichiesta.metadata.cessioneVoltura.noVariazioneInd ==
            null
          ) {
            return false;
          } else if (
            self.dettaglioRichiesta.metadata.cessioneVoltura.noVariazioneInd !=
            null &&
            !self.dettaglioRichiesta.metadata.cessioneVoltura.noVariazioneInd
          ) {
            return self.validityIndirizziCess;
          } else {
            return true;
          }
        }
        if (self.getWizardMap(self.dettaglioRichiesta.viewIndex) == "PQVA") {
          //qva cessionario
          return self.validityQva;
        }
        if (self.getWizardMap(self.dettaglioRichiesta.viewIndex) == "PBEI") {
          //bei cessionario
          return self.enableFondiBei;
        }
        if (self.getWizardMap(self.dettaglioRichiesta.viewIndex) == "RA4") {
          return (
            !self.richiestePostVendita.metadata.cessioneVoltura.terzo
              .datiIncompleti && self.supportModel.fatturazioneOk
          );
        }
      };

      self.backValidity = function () {
        return self.getWizardMap(self.dettaglioRichiesta.viewIndex) === "PC11" ?
          false :
          true;
      };

      self.next = function (fromModal) {
        self.loaderObj.enabledLoader = true;
        switch (self.getWizardMap(self.dettaglioRichiesta.viewIndex)) {
          case "PC11":
            if (fromModal) {
              $modalService.closeModal("messageCessione");
              $RichiestePostVenditaService
                .getFlagPagobolloCessVolt(self.dettaglioRichiesta)
                .then((response) => {
                  self.dettaglioRichiesta.metadata.cessioneVoltura.flagPagobollo =
                    response.id;
                  $RichiestePostVenditaService
                    .generateAllegatiPv(self.dettaglioRichiesta)
                    .then(function (response) {
                      if (response.success) {
                        $RichiestePostVenditaService
                          .nextStepPv(
                            self.dettaglioRichiesta,
                            self.dettaglioRichiesta.typeWf,
                            self.dettaglioRichiesta.applicationName,
                            true
                          )
                          .then(function (responseNext) {
                            self.dettaglioRichiesta = responseNext;
                            if (responseNext.goHome) {
                              submitCedente();
                            } else {
                              if (
                                self.getWizardMap(
                                  self.dettaglioRichiesta.viewIndex
                                ) == "PCDCK"
                              ) {
                                retrieveStepInfo();
                                populateCheckList();
                              }
                            }
                            self.loaderObj.enabledLoader = false;
                          })
                          .catch(function (error) {
                            console.log(error);
                            self.loaderObj.enabledLoader = false;
                          });
                      } else {
                        self.loaderObj.enabledLoader = false;
                      }
                    })
                    .catch(function (error) {
                      self.loaderObj.enabledLoader = false;
                      console.log(error);
                    });
                })
                .catch(function (error) {
                  self.loaderObj.enabledLoader = false;
                  console.log(error);
                })
            } else {
              $RichiestePostVenditaService
                .preStartCessione(
                  self.dettaglioRichiesta.metadata.ctrRichiestaList,
                  self.dettaglioRichiesta.metadata.message,
                  self.dettaglioRichiesta.subtype,
                  self.dettaglioRichiesta.type
                )
                .then(function (response) {
                  if (response.success) {
                    if (response.showPopup) {
                      $modalService.openModal("messageCessione");
                      self.messages = response.messages;
                      self.loaderObj.enabledLoader = false;
                      self.blockingPopup = response.blocked;
                      return;
                    }
                    $RichiestePostVenditaService
                      .getFlagPagobolloCessVolt(self.dettaglioRichiesta)
                      .then((response) => {
                        self.dettaglioRichiesta.metadata.cessioneVoltura.flagPagobollo =
                          response.id;
                        $RichiestePostVenditaService
                          .generateAllegatiPv(self.dettaglioRichiesta)
                          .then(function (response) {
                            if (response.success) {
                              $RichiestePostVenditaService
                                .nextStepPv(
                                  self.dettaglioRichiesta,
                                  self.dettaglioRichiesta.typeWf,
                                  self.dettaglioRichiesta.applicationName,
                                  true
                                )
                                .then(function (responseNext) {
                                  self.dettaglioRichiesta = responseNext;
                                  if (responseNext.goHome) {
                                    submitCedente();
                                  } else {
                                    if (
                                      self.getWizardMap(
                                        self.dettaglioRichiesta.viewIndex
                                      ) == "PCDCK"
                                    ) {
                                      retrieveStepInfo();
                                      populateCheckList();
                                    }
                                  }
                                  self.loaderObj.enabledLoader = false;
                                })
                                .catch(function (error) {
                                  console.log(error);
                                  self.loaderObj.enabledLoader = false;
                                });
                            } else {
                              self.loaderObj.enabledLoader = false;
                            }
                          })
                          .catch(function (error) {
                            self.loaderObj.enabledLoader = false;
                            console.log(error);
                          });
                      })
                      .catch((error) => {
                        self.loaderObj.enabledLoader = false;
                        console.log(error);
                      });
                  }
                })
                .catch(function (error) {
                  console.log(error);
                  self.loaderObj.enabledLoader = false;
                });
            }
            break;
          case "PCDCK":
            if (fromModal) {
              $modalService.closeModal("confermaCessione");
              submitCedente();
            } else {
              $modalService.openModal("confermaCessione");
              self.loaderObj.enabledLoader = false;
            }
            break;
          case "RIANAG":
            $RichiestePostVenditaService
              .nextStepPv(
                self.dettaglioRichiesta,
                self.dettaglioRichiesta.typeWf,
                self.dettaglioRichiesta.applicationName,
                true
              )
              .then(function (responseNext) {
                self.dettaglioRichiesta = responseNext;
                self.loaderObj.enabledLoader = false;
                if (
                  self.getWizardMap(self.dettaglioRichiesta.viewIndex) ==
                  "PCSDA"
                ) {
                  getDealer();
                }
              })
              .catch(function (error) {
                console.log(error);
                self.loaderObj.enabledLoader = false;
              });
            break;
          case "PCSDA":
          case "PMPLINST":
            $RichiestePostVenditaService
              .getFlagPagobolloCessVolt(self.dettaglioRichiesta)
              .then((response) => {
                self.dettaglioRichiesta.metadata.cessioneVoltura.flagPagobollo =
                  response.id;
                $RichiestePostVenditaService
                  .generateAllegatiPv(self.dettaglioRichiesta)
                  .then(function (response) {
                    if (response.success) {
                      $RichiestePostVenditaService
                        .nextStepPv(
                          self.dettaglioRichiesta,
                          self.dettaglioRichiesta.typeWf,
                          self.dettaglioRichiesta.applicationName,
                          true
                        )
                        .then(function (responseNext) {
                          self.dettaglioRichiesta = responseNext;
                          if (
                            self.getWizardMap(
                              self.dettaglioRichiesta.viewIndex
                            ) == "PQVA"
                          ) {
                            self.loaderObj.enabledLoader = false;
                            retrieveStepInfo();
                            if (self.appContracts[0].numeroContratto == "") {
                              self.dettaglioRichiesta.metadata.cessioneVoltura.contratti.forEach(
                                function (contratto) {
                                  self.appContracts.forEach(function (element) {
                                    if (
                                      contratto.selected &&
                                      element.numeroContratto !=
                                        contratto.numero &&
                                      element.modulo != contratto.modulo
                                    ) {
                                      self.appContracts.push({
                                        numeroContratto: contratto.numero,
                                        modulo: contratto.modulo,
                                        prodotto: contratto.codProdotto,
                                      });
                                    }
                                  });
                                }
                              );
                            }
                            self.appContracts = self.appContracts.filter(
                              function (element) {
                                return (
                                  element.numeroContratto != "" &&
                                  element.modulo != "" &&
                                  element.prodotto != ""
                                );
                              }
                            );
                            if (
                              !self.dettaglioRichiesta.metadata
                                .cessioneVoltura.questComplete
                            ) {
                              retrieveQvaList();
                            }
                          } else if (
                            self.getWizardMap(
                              self.dettaglioRichiesta.viewIndex
                            ) == "PCSCK"
                          ) {
                            self.loaderObj.enabledLoader = false;
                            retrieveStepInfo();
                            populateCheckList();
                          } else {
                            self.loaderObj.enabledLoader = false;
                          }
                        })
                        .catch(function (error) {
                          console.log(error);
                          self.loaderObj.enabledLoader = false;
                        });
                    }
                  })
                  .catch(function (error) {
                    console.log(error);
                    self.loaderObj.enabledLoader = false;
                  });
              })
              .catch((error) => {
                console.log(error);
                self.loaderObj.enabledLoader = false;
              });

            break;
          case "PQVA":
          case "PBEI":
            $RichiestePostVenditaService
              .getFlagPagobolloCessVolt(self.dettaglioRichiesta)
              .then((response) => {
                self.dettaglioRichiesta.metadata.cessioneVoltura.flagPagobollo =
                  response.id;
                $RichiestePostVenditaService
                  .generateAllegatiPv(self.dettaglioRichiesta)
                  .then(function (response) {
                    if (response.success) {
                      $RichiestePostVenditaService
                        .nextStepPv(
                          self.dettaglioRichiesta,
                          self.dettaglioRichiesta.typeWf,
                          self.dettaglioRichiesta.applicationName,
                          true
                        )
                        .then(function (responseNext) {
                          self.dettaglioRichiesta = responseNext;
                          if (responseNext.goHome) {
                            submitCedente();
                          } else {
                            if (
                              self.getWizardMap(
                                self.dettaglioRichiesta.viewIndex
                              ) == "PCSCK"
                            ) {
                              retrieveStepInfo();
                              populateCheckList();
                            }
                          }
                          self.loaderObj.enabledLoader = false;
                        })
                        .catch(function (error) {
                          console.log(error);
                          self.loaderObj.enabledLoader = false;
                        });
                    } else {
                      self.loaderObj.enabledLoader = false;
                    }
                  })
                  .catch(function (error) {
                    console.log(error);
                    self.loaderObj.enabledLoader = false;
                  });
              })
              .catch((error) => {
                console.log(error);
                self.loaderObj.enabledLoader = false;
              });

            break;
          case "PCSCK":
            $RichiestePostVenditaService
              .submitCessionario(
                self.dettaglioRichiesta.metadata.cessioneVoltura,
                self.dettaglioRichiesta.id,
                self.dettaglioRichiesta.viewIndex,
                self.dettaglioRichiesta.applicationName,
                self.dettaglioRichiesta.typeWf
              )
              .then(function (response) {
                if (response.success) {
                  $location.path("/");
                }
                self.loaderObj.enabledLoader = false;
              })
              .catch(function (error) {
                console.log(error);
                self.loaderObj.enabledLoader = false;
              });
            break;
        }
      };

      self.back = function () {
        if (self.dettaglioRichiesta.readOnly) {
          $location.path('/');
        } else {
          self.enabledBackLoader = true;
          self.dettaglioRichiesta.type = "02";
          self.dettaglioRichiesta.subtype = "011";
          $RichiestePostVenditaService
            .backStepPv(
              self.dettaglioRichiesta,
              self.dettaglioRichiesta.typeWf,
              self.dettaglioRichiesta.applicationName,
              true
            )
            .then(function (response) {
              self.enabledBackLoader = false;
              self.dettaglioRichiesta = response;
              retrieveStepInfo();
              // self.nextValidity()
            })
            .catch(function (error) {
              console.log(error);
              self.enabledBackLoader = false;
            });
        }
      };

      self.sospendi = function () {
        $RichiestePostVenditaService
          .suspendInstance(
            self.dettaglioRichiesta,
            self.dettaglioRichiesta.typeWf,
            self.dettaglioRichiesta.applicationName,
            true
          )
          .then(function () {
            $location.path("/");
            $modalService.closeModal("suspendInstance");
          });
      };

      self.closeModal = function () {
        $('.financial-leasing__footer').css("z-index", "1");
        $modalService.closeModal("suspendInstance");
        $modalService.closeModal("confermaCessione");
        $modalService.closeModal("messageCessione");
      };

      self.exportValidityIndirizziCess = function (validity) {
        self.validityIndirizziCess = validity;
      };

      self.exportValidityDatiRichiesta = function (validity) {
        self.validityDatiRichiesta = validity;
      }

      self.exportValidityDatiCess = function (validity) {
        self.validityDatiCess = validity;
        self.datiAnagCompleti = validity;
      }

      self.exportValidityQva = function (validity) {
        self.validityQva = validity;
      }

      self.validityFondiBei = function (value) {
        self.enableFondiBei = value;
      };

      self.validateCheckBoxCategory = function (validity) {
        self.checkCategory = validity;
        self.dettaglioRichiesta.metadata.cessioneVoltura.qcc.consensiOk = validity;
      }

      self.validateContact = function (validation) {
        self.isContact = validation;
      };

      self.validateIban = function (validation) {
        self.isIban = validation;
      };

      self.validateClientData = function (validity) {
        self.clientDataVal = validity;
      }

      self.validateUpload = function (validity) {
        self.documentUploaded = validity;
      }

      self.fatturazioneElettronica = function (value, result) {
        if (result === true) {
          self.dettaglioRichiesta.metadata.cessioneVoltura.fatturazioneElettronica = value;
        }

        self.isFatturazioneElett = self.dettaglioRichiesta.metadata.cessioneVoltura.fatturazioneElettronica.cdDestinatarioFatturazione ||
          self.dettaglioRichiesta.metadata.cessioneVoltura.fatturazioneElettronica.emailFatturazioneElettronica ? true : false;
      };

      self.getWizardMap = function (viewIndex) {
        if (
          $rootScope.wizardMap.find(function (element) {
            return element.index == viewIndex;
          })
        ) {
          return $rootScope.wizardMap.find(function (element) {
            return element.index == viewIndex;
          }).viewName;
        }
      };

      self.validatePage = function (validity) {
        self.validityComponentUpload = validity;
      };

      self.validateUpload = function (validity) {
        self.validityComponentUpload = validity;
        // self.nextValidity();
      };

      var retrieveQvaList = function () {
        self.dettaglioRichiesta.metadata.cessioneVoltura.questionarioQva = [];
        self.restQvaRunning = true;
        $RichiestePostVenditaService
          .getListQvaData(self.appContracts, self.dettaglioRichiesta.id)
          .then(function (response) {
            if (response.success) {
              for (var key in response.mapQva) {
                if (self.dettaglioRichiesta.metadata.cessioneVoltura.questionarioQva.length > 0) {
                  self.dettaglioRichiesta.metadata.cessioneVoltura.questionarioQva.forEach(function (element) {
                    if (response.mapQva[key].contratto != element.contratto ||
                      (response.mapQva[key].contratto == element.contratto && response.mapQva[key].modulo != element.modulo)) {
                      self.dettaglioRichiesta.metadata.cessioneVoltura.questionarioQva.push(response.mapQva[key]);
                    }
                  });
                } else {
                  self.dettaglioRichiesta.metadata.cessioneVoltura.questionarioQva.push(response.mapQva[key]);
                }
              }
            }
            self.restQvaRunning = false;
          })
          .catch(function (error) {
            console.log(error);
            self.restQvaRunning = false;
          });
      }

      var retrieveStepInfo = function () {
        self.clearLabelInfo = true;
        $RichiestePostVenditaService
          .getStepInfo(self.dettaglioRichiesta.id, self.dettaglioRichiesta.viewIndex)
          .then(function (response) {
            if (response.success) {
              self.showMapInfo = response.showBeMessage;
              self.mapInfo = response.message;
              self.loaderObj.enabledLoader = false;
            }
            self.clearLabelInfo = false;

          })
          .catch(function (error) {
            console.log(error);
            self.loaderObj.enabledLoader = false;
            self.clearLabelInfo = false;
          });
      }

      self.fattElettronica = function (fattElettronica, value) {
        if (fattElettronica) {
          self.richiestePostVendita.metadata.cessioneVoltura.terzo.sedeFatturazione.fatturazione = fattElettronica;
          self.supportModel.fatturazioneOk = value;
          checkValidity();
        }
      }

      var getDealer = function () {
        self.gettingDealer = true;
        $userService.getDealerUser().then(function (dealer) {
          if (dealer) {
            self.dettaglioRichiesta.metadata.cessioneVoltura.firmatario.nome = dealer.name;
            self.dettaglioRichiesta.metadata.cessioneVoltura.firmatario.cognome = dealer.surname;
            self.dettaglioRichiesta.metadata.cessioneVoltura.firmatario.cf = dealer.cf;
          }
          self.gettingDealer = false;
        });
      };

      var checkCf = function () {
        if (
          self.dettaglioRichiesta.metadata.cessioneVoltura.firmatario &&
          self.dettaglioRichiesta.metadata.cessioneVoltura.firmatario.nome &&
          self.dettaglioRichiesta.metadata.cessioneVoltura.firmatario.cognome &&
          self.dettaglioRichiesta.metadata.cessioneVoltura.firmatario.cf
        ) {
          $timeout(function () {
            self.codiceFiscaleOk = validationService.checkCfWithName(
              self.dettaglioRichiesta.metadata.cessioneVoltura.firmatario.cf,
              self.dettaglioRichiesta.metadata.cessioneVoltura.firmatario
                .cognome,
              self.dettaglioRichiesta.metadata.cessioneVoltura.firmatario.nome
            );
          }, 500);
        }
      };

      var submitCedente = function () {
        $RichiestePostVenditaService
          .submitCedente(
            self.dettaglioRichiesta.metadata.cessioneVoltura,
            self.dettaglioRichiesta.id,
            self.dettaglioRichiesta.viewIndex,
            self.dettaglioRichiesta.applicationName,
            self.dettaglioRichiesta.typeWf
          )
          .then(function (response) {
            if (response.success) {
              $location.path("/");
            }
            self.loaderObj.enabledLoader = false;
          })
          .catch(function (error) {
            console.log(error);
            self.loaderObj.enabledLoader = false;
          });
      }

      var populateCheckList = function () {
        self.restChecklistRunning = true;
        $arcService
          .checklistPv(self.dettaglioRichiesta)
          .then(function (response) {
            if (response.success) {
              self.listOfDocumentUpload = response.listDocuments;
              self.visibleUploadChecklist = response.visible;
              self.messageUpload = response.messageUpload;
              self.messageDownload = response.messageDownload;
            }
            self.restChecklistRunning = false;
          })
          .catch(function (error) {
            self.restChecklistRunning = false;
            console.error(error);
          });
      };

      self.confirmMessageCessione = function () {
        if (!self.blockingPopup) {
          self.next(true);
        } else {
          $modalService.closeModal("messageCessione");
          self.sospendi()
        }
      };
    }
  });